'use strict';

class reportService {
  constructor($http, $filter) {
    this.$http = $http;
    this.$filter = $filter;
  }

  getAttachments(params = {}) {
    return this.$http.get('/reports/invoices/attachments', {
      params: params
    });
  }

  availableColumns(type) {
    return this.$http.get(`/reports/${type}/availableColumns`);
  }

  sendEmail(params) {
    return this.$http.post(`/reports/email`, params);
  }

  generate(type, params) {
    return this.$http.get(`/reports/${type}`, {
      params: params
    });
  }

  download(context, params = {}, email = false) {
    return this.$http.get(`/reports/${context}`, {
      params: params,
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp && !email) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'rapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      } else {
        return true;
      }
    });
  }

  invoicePdfForRecipient(year, recipientNo) {
    return this.$http.get('/reports/invoices/recipient/' + recipientNo + '/year/' + year, {
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'rapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      } else {
        return true;
      }
    });
  }

  years() {
    let y = [];
    let currentYear = moment().year();

    for (let i = 2003; i <= currentYear; i++) {
      y.push(i);
    }

    return y;
  }

  checkType(val) {
    if (val && val !== null) {
      if (angular.isNumber(val)) {
        return this.$filter('crowns')(val, false);
      } else {
        if (val.match(/^\d{4}[\-]\d{2}[\-]\d{2}$/)) {
          return this.$filter('dateFormat')(val);
        } else {
          return val;
        }
      }
    } else {
      return val;
    }
  }

  // EXPORT
  createBatch(params) {
    return this.$http.post(`/export/batches`, params);
  }

  getBatches() {
    return this.$http.get(`/export/batches`);
  }

  getBatch(number) {
    return this.$http.get(`/export/batches/${number}`);
  }

  downloadBatch(number) {
    return this.$http.get(`/export/batches/${number}/download?format=vismaglobal`, {
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'rapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      }
    });
  }
}

reportService.$inject = ['$http', '$filter'];

angular
  .module('SendRegning')
  .service('reportService', reportService);
